export const rideryCodesTableHeader = [
  { name: "Código Descuento", value: "code", sortable: false },
  { name: "Status", value: "status", sortable: false },
  { name: "Accion", value: "actions", sortable: false },
];